import { render, staticRenderFns } from "./budgetProportionAnalysis.vue?vue&type=template&id=3654106e&scoped=true&"
import script from "./budgetProportionAnalysis.vue?vue&type=script&lang=js&"
export * from "./budgetProportionAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./budgetProportionAnalysis.vue?vue&type=style&index=0&id=3654106e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3654106e",
  null
  
)

export default component.exports